module.exports = __webpack_public_path__ + "img/Checkout.3e35baa0.svg";